<span class="details-view-container" *ngIf="showDetails">
  <div id="offset-anchor"></div>
  <div [ngSwitch]='type'>
    <div class="details-view-old" *ngSwitchCase="'old'">
      <div [innerHTML]="sameAsHtml(data)"></div>
    </div>
    <div class="details-view" *ngSwitchCase="'new'">
      <div class="details-title" *ngIf='showActuality ; else noActuality'><span>{{title}}</span> <span>(Actualiteit: {{actualityDateTime}})</span> </div>
      <ng-template #noActuality> <div class="details-title">{{title}}</div></ng-template>
      <div [hidden]="hideExpandButton" class="expand-all-button" [ngClass]="{'expanded': allExpanded}"
           (click)="expandOrCollapseAll()">{{allExpanded ?  collapseAll : expandAll}}<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" focusable="false"><path xmlns="http://www.w3.org/2000/svg" d="m 1.9,367.4 v 50.9 L 256,235.5 510.1,418.3 V 367.4 L 256,184.8" id="path3753" xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" inkscape:connector-curvature="0"/><path xmlns="http://www.w3.org/2000/svg" d="m 2.78079,227.08179 v 50.9 l 254.1,-182.8 254.1,182.8 v -50.9 l -254.1,-182.6" id="path3753-4" xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" inkscape:connector-curvature="0"/></svg>
      </div>
      <ng-container #button></ng-container>
      <ng-container #panel></ng-container>
      <div [hidden]="hideErrorText" class="error-text">
      {{errorText}}
      </div>
    </div>
    <div *ngSwitchDefault></div>
  </div>
</span>

